import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

type ManualValidationPayload = {
  workItemID?: string;
  activityItemCode: string;
  zIdentifier?: string;
  profile?: string;
  supplierCode?: string;
  fieldglassId?: string;
  validationExpirationDate?: Date;
  hasInfiniteLifetime?: boolean;
  reason?: string;
};

const workItemManualValidation = async (
  manualValidationPayload: ManualValidationPayload,
) => {
  return await apiInputService.post(
    "/manual-validation",
    manualValidationPayload,
  );
};

export const useWorkItemManualValidation = (options?: any) => {
  return useMutation(workItemManualValidation, {
    ...options,
  });
};
